
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
            <h1 className="text-6xl font-bold text-red-600 mb-4">404</h1>
            <h2 className="text-2xl md:text-3xl font-semibold mb-4">Page Not Found</h2>
            <p className="text-gray-600 mb-6 text-center">
                Sorry, the page you are looking for does not exist. <br />
                It might have been removed, renamed, or is temporarily unavailable.
            </p>
            <Link
                to="/"
                className="px-6 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition"
            >
                Go Back Home
            </Link>
        </div>
    );
};

export default NotFound;
